"use client"

import { useCallback } from "react"
import { TIconButton } from "../../ui/button/TIconButton"
import { ImageCard } from "./image-card"

interface DualImageUploadProps {
	value: string[]
	onChange: (value: string[]) => void
	onWorkHistorySelect?: () => Promise<string[]>
}

export function DualImageUpload({ value, onChange, onWorkHistorySelect }: DualImageUploadProps) {
	const handleImageChange = useCallback(
		(index: number) => (newImage: string) => {
			const newValue = [...(value || []), "", ""].slice(0, 2)
			newValue[index] = newImage
			onChange(newValue)
		},
		[value, onChange]
	)

	const handleWorkHistorySelect = useCallback(
		async (index: number) => {
			if (!onWorkHistorySelect) return

			try {
				const selectedImages = await onWorkHistorySelect()
				if (selectedImages.length > 0) {
					handleImageChange(index)(selectedImages[0] as string)
				}
			} catch (error) {
				console.error("Failed to select image from work history:", error)
			}
		},
		[onWorkHistorySelect, handleImageChange]
	)

	const handleSwap = useCallback(() => {
		const images = value || []
		const image0 = images[0] || ""
		const image1 = images[1] || ""

		if (image0 || image1) {
			onChange([image1, image0])
		}
	}, [value, onChange])

	const images = value || []
	const showSwapButton = images.some((img) => img)

	return (
		<div className="space-y-4">
			<div className="relative grid grid-cols-2 gap-2">
				{Array.from({ length: 2 }).map((_, index) => (
					<div key={index}>
						<ImageCard
							index={index}
							value={images[index] || ""}
							onChange={handleImageChange(index)}
							onWorkHistorySelect={onWorkHistorySelect ? () => handleWorkHistorySelect(index) : undefined}
						/>
					</div>
				))}
				{showSwapButton && (
					<TIconButton
						name="arrowsHorizontal"
						size="small"
						color="tertiary"
						onClick={handleSwap}
						className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-10"
					/>
				)}
			</div>
		</div>
	)
}
